import styled from 'styled-components';

export const SearchableListContent = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 12px;
    align-items: center;
    justify-content: center;
    width: 100%;
    overflow-y: auto;
`;

export const SearchableListContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    width: 100%;
    height: 100%;

    & > owc-input {
        width: 100% !important;
    }
`;
